import { KeyValuePairCollection } from './kvp.collection';

export const LinkLocation: KeyValuePairCollection<number> = new KeyValuePairCollection<number>([
  { key: 'Footer', value: 0 },
  { key: 'Header', value: 1 }
]);
